// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__vPZZW","bigColWidth":"Table_bigColWidth__zgQ5e","biggerColWidth":"Table_biggerColWidth__1UAQN","row":"Table_row__HdYKn","col":"Table_col__3rtHm"};